/**
 * @generated SignedSource<<9e76ab10079ddc5bd9646614f150b688>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type multipleFlags_softwareReleasesVersionDetailIssueList_jiraIssue$data = {
  readonly id: string;
  readonly " $fragmentType": "multipleFlags_softwareReleasesVersionDetailIssueList_jiraIssue";
};
export type multipleFlags_softwareReleasesVersionDetailIssueList_jiraIssue$key = {
  readonly " $data"?: multipleFlags_softwareReleasesVersionDetailIssueList_jiraIssue$data;
  readonly " $fragmentSpreads": FragmentRefs<"multipleFlags_softwareReleasesVersionDetailIssueList_jiraIssue">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "multipleFlags_softwareReleasesVersionDetailIssueList_jiraIssue",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "id"
      },
      "action": "THROW",
      "path": "id"
    }
  ],
  "type": "JiraIssue"
};

(node as any).hash = "895bdec15c863c74e317666c4dea1c42";

export default node;
